
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    IconButton,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useState } from "react";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "900px",
    height: "auto",
    maxHeight: "90vh",
    bgcolor: "background.paper",
    border: "1px solid #fff",
    boxShadow: 24,
    p: 1,
};
function VesselDeatils({ vesselDetail }: { vesselDetail: any[] }) {
    const [open, setOpen] = useState(false);

    const handleOpen = (event: any) => {
        event.preventDefault();
        setOpen(true);
    };
    const handleClose = (event: any) => {
        event.preventDefault();
        setOpen(false);
    };

    return <>
        <div className="2xl:col-span-12 xl:col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
            <div className="flex justify-end">
                <button
                    className="btn btnTheme"
                    onClick={handleOpen}
                >
                    Check Vessel Details
                </button>
            </div>
        </div>
        <Modal
            open={open}
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose(event);
                }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableEnforceFocus
            disableAutoFocus
        >
            <Box sx={style} onClick={(e) => e.stopPropagation()}>
                <h3
                    id="modal-modal-title"
                    className="text-xl font-bold text-center text-yellow-500 bg-yellow-50 py-2 px-3 rounded-lg mb-2"
                >
                    Vessel Details
                </h3>
                <TableContainer
                    className="modelTable"
                    component={Paper}
                    sx={{
                        maxHeight: 400,
                        overflowY: "auto",
                    }}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>Vessel Name</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>Voyage</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>Origin</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>Destination</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>ETD</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>ETA</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>ATD</strong>
                                </TableCell>
                                <TableCell sx={{ borderRight: "1px solid #ccc" }}>
                                    <strong>ATA</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {vesselDetail.map((item: any, index: any) => (
                                <TableRow key={index}>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.name || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.voyage || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.origin || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.destination || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.etd || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.eta || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.atd || ""}
                                    </TableCell>
                                    <TableCell
                                        sx={{ borderRight: "1px solid #ccc" }}
                                    >
                                        {item.ata || ""}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="flex justify-end">
                    <button
                        className="btn btnTheme mt-4 p-1"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </Box>
        </Modal>
    </>
}

export default VesselDeatils;